import {PaymentCurrency} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/subscriptionWorkspaceCapability/domain/PaymentCurrency";
import {PaymentFrequency} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/subscriptionWorkspaceCapability/domain/PaymentFrequency";

export const paymentCurrencyToDetailsMap: Record<
    PaymentCurrency,
    {
        id: PaymentCurrency;
        displayName: string;
        symbol: string;
    }
> = {
    [PaymentCurrency.inr]: {
        id: PaymentCurrency.inr,
        displayName: "INR",
        symbol: "₹",
    },
    [PaymentCurrency.usd]: {
        id: PaymentCurrency.usd,
        displayName: "USD",
        symbol: "$",
    },
};

export const allPaymentCurrencies: Array<PaymentCurrency> = [PaymentCurrency.inr, PaymentCurrency.usd];

export const defaultPaymentCurrency: PaymentCurrency = PaymentCurrency.inr;

export function isPaymentFreuquency(value: string): value is PaymentFrequency {
    return Object.values(PaymentFrequency).includes(value as PaymentFrequency);
}

export const paymentFrequencyToDetailsMap: Record<
    PaymentFrequency,
    {
        id: PaymentFrequency;
        displayName: string;
        unit: string;
    }
> = {
    [PaymentFrequency.yearly]: {
        id: PaymentFrequency.yearly,
        displayName: "Yearly",
        unit: "year",
    },
    [PaymentFrequency.monthly]: {
        id: PaymentFrequency.monthly,
        displayName: "Monthly",
        unit: "month",
    },
    [PaymentFrequency.weekly]: {
        id: PaymentFrequency.weekly,
        displayName: "Weekly",
        unit: "week",
    },
    [PaymentFrequency.everyTwoDays]: {
        id: PaymentFrequency.everyTwoDays,
        displayName: "Every two days",
        unit: "2 days",
    },
    [PaymentFrequency.everyThreeDays]: {
        id: PaymentFrequency.everyThreeDays,
        displayName: "Every three days",
        unit: "3 days",
    },
    [PaymentFrequency.everyFourDays]: {
        id: PaymentFrequency.everyFourDays,
        displayName: "Every four days",
        unit: "4 days",
    },
};

export const defaultPaymentFrequency = PaymentFrequency.monthly;
